import React, { FunctionComponent } from "react";
import styles from "../css/Section4.module.css";
import { FragmentRo } from "../../svg_groups/fragment_ro";
import { useSelector } from "react-redux";
import { FragmentEng } from "../../svg_groups/fragment_en";

const Section4 = () => {
  const language = useSelector((state: any) => state.language.value);
  return (
    <div className={styles.mainContainer}>
      <div className={styles.frameLeft}>
        <div className={styles.title}>
          <span className={styles.whoWillLikeThisBook}>
            {language === "EN" && "This book is for you if:"}
            {language === "RO" && "Această carte este pentru tine dacă:"}
          </span>
          <span className={styles.whoWillLikeThisBook1}>
            {language === "EN" && "This book is for you if:"}
            {language === "RO" && "Această carte este pentru tine dacă:"}{" "}
          </span>
        </div>
        <div className={styles.bookPhoto9} />
      </div>

      <div className={styles.frame}>
        <div className={styles.itemsContainer}>
          <div className={styles.item}>
            <div className={styles.itemContent}>
              <span className={styles.itemNumber}>01.</span>
              <div className={styles.itemTextWrapper}>
                <p className={styles.itemText}>
                  {language === "RO" ? (
                    <>
                      Ești în căutarea unei povești care <em>inspiră</em> și
                      aduce cu sine conștientizări profunde.
                    </>
                  ) : (
                    <>
                      You're looking for a story that <em>inspires</em> and
                      brings deep insights.
                    </>
                  )}
                </p>
                <div className={styles.divider} />
              </div>
            </div>
          </div>

          <div className={styles.item}>
            <div className={styles.itemContent}>
              <span className={styles.itemNumber}>02.</span>
              <div className={styles.itemTextWrapper}>
                <p className={styles.itemText}>
                  {language === "EN"
                    ? "You want to reconnect with yourself and live life to its fullest."
                    : "Vrei să te reconectezi cu tine și să trăiești viața în toată profunzimea ei."}
                </p>
                <div className={styles.divider} />
              </div>
            </div>
          </div>

          <div className={styles.item}>
            <div className={styles.itemContent}>
              <span className={styles.itemNumber}>03.</span>
              <div className={styles.itemTextWrapper}>
                <p className={styles.itemText}>
                  {language === "EN"
                    ? "You've lost your way in life and want to find the light at the end of the tunnel."
                    : "Te-ai rătăcit prin viață și vrei să găsești lumina la capătul tunelului."}
                </p>
                <div className={styles.divider} />
              </div>
            </div>
          </div>

          <div className={styles.item}>
            <div className={styles.itemContent}>
              <span className={styles.itemNumber}>04.</span>
              <div className={styles.itemTextWrapper}>
                <p className={styles.itemText}>
                  {language === "EN"
                    ? "You feel it's time for a change, but lack the courage and confidence."
                    : "Simți că e momentul pentru o schimbare, dar curajul și încrederea îți lipsesc."}
                </p>
                <div className={styles.divider} />
              </div>
            </div>
          </div>

          <div className={styles.item}>
            <div className={styles.itemContent}>
              <span className={styles.itemNumber}>05.</span>
              <div className={styles.itemTextWrapper}>
                <p className={styles.itemText}>
                  {language === "EN"
                    ? "You're in a stagnant relationship and searching for the right direction."
                    : "Ești într-o relație de iubire care stagnează și cauți direcția potrivită."}
                </p>
                <div className={styles.divider} />
              </div>
            </div>
          </div>

          <div className={styles.item}>
            <div className={styles.itemContent}>
              <span className={styles.itemNumber}>06.</span>
              <div className={styles.itemTextWrapper}>
                <p className={styles.itemText}>
                  {language === "EN"
                    ? "You need support when your friends no longer understand you."
                    : "Ai nevoie de susținere, atunci când prietenii nu te mai înțeleg."}
                </p>
                <div className={styles.divider} />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.frameRight}>
        <div className={styles.bookPhoto} />
        <div className={styles.rotatingText2PParentParent}>
          <g className={styles.arrow}>
            <svg
              width="12"
              height="42"
              viewBox="0 0 12 42"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.89155 41.6397C6.18444 41.9326 6.65931 41.9326 6.95221 41.6397L11.7252 36.8667C12.0181 36.5738 12.0181 36.099 11.7252 35.8061C11.4323 35.5132 10.9574 35.5132 10.6645 35.8061L6.42188 40.0487L2.17924 35.8061C1.88634 35.5132 1.41147 35.5132 1.11858 35.8061C0.825682 36.099 0.825683 36.5738 1.11858 36.8667L5.89155 41.6397ZM5.67188 0.109375L5.67188 41.1094L7.17188 41.1094L7.17188 0.109375L5.67188 0.109375Z"
                fill="#C4B57C"
              />
            </svg>
          </g>
          <div className={styles.rotatingText2PParent}>
            {language == "RO" && <FragmentRo />}
            {language == "EN" && <FragmentEng />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Section4;
